
import regex from "./regex";
import storage from "./storage";

export const validateUrl = (url) => {
    return regex.URL.test(url)
}

export const validateStatefilePath = (path) => {
    return (
      path.match(regex.stateFile) &&
      path.match(regex.stateFile).length === path.split(",").length
    );
}

export const debounce = (func, delay = 500) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}

export const findRegionFromTFJson = (arr) => {
    return arr?.filter(item => item.name === 'region')[0]
}

export const findUserRole = () => {
    return storage.getItem("auth")
}

export const getCredentialsBasedOnRoles = (allCredentials, loggedUser) => {
    if (isAdmin(loggedUser?.roles)) {
        return allCredentials
    }
    return allCredentials.filter(cred => loggedUser?.accounts.includes(cred.accountNumber))
}

export const isAdmin = (roles) => {
    return roles?.includes("admin")
}

export const generateFormData = (payload) => {
    const formData = new FormData();
    for (const key in payload) {
        if (payload.hasOwnProperty(key)) {
            formData.append(key, payload[key] ?? "")
        }
    }
    return formData
}

export const openInNewTab = (url = '') => {
    window.open(url, '_blank', 'noopener,noreferrer');
};

export const capitalizeWords = (input = "") => {
    return input.split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
